module.exports = __webpack_public_path__ + "static/img/american-express-straight-128px.0c380c39.png";